import * as React from 'react';
import { motion } from 'framer-motion';

// Simple utility function for class names
function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

function Checkbox({
  className,
  onCheckedChange,
  checked,
  defaultChecked,
  id,
  ...props
}) {
  const [isChecked, setIsChecked] = React.useState(checked ?? defaultChecked ?? false);

  React.useEffect(() => {
    if (checked !== undefined) setIsChecked(checked);
  }, [checked]);

  const handleCheckedChange = React.useCallback((event) => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    onCheckedChange?.(newChecked, event);
  }, [isChecked, onCheckedChange]);

  const checkboxStyles = {
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    border: isChecked ? '3px solid #2563eb' : '3px solid #d1d5db',
    backgroundColor: isChecked ? '#2563eb' : '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
  };

  return (
    <motion.button
      type="button"
      role="checkbox"
      aria-checked={isChecked}
      data-state={isChecked ? "checked" : "unchecked"}
      style={checkboxStyles}
      className={cn('checkbox-component', className)}
      onClick={handleCheckedChange}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.05 }}
      {...props}>
      {isChecked && (
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="3.5"
          stroke="currentColor"
          style={{ width: '20px', height: '20px', color: '#ffffff' }}
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 0.2, delay: 0.1 }}>
          <motion.path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.2, delay: 0.2 }} />
        </motion.svg>
      )}
    </motion.button>
  );
}

Checkbox.displayName = 'Checkbox';

export { Checkbox };
